export function getTranslation(lang: string): {
    downPaymentLargerThanPurchasePrice: string;
    enterDownPaymentMinimum: string;
    failedToLoad: string;
    loading: string;
    youCannotExceedLoan: string;
    loanCantBeLessThan: string;
    loanCantBeLargerThan: string;
    refinanceCantBeGreaterThanHomeValue: string;
    ltvShouldBeValueOrLess: string;
} {
    const translationStrings = {
        en: {
            downPaymentLargerThanPurchasePrice: 'Your down payment cannot be equal to or larger than the Purchase price.',
            enterDownPaymentMinimum: 'Enter a down payment of {0}% or more for this loan type.',
            failedToLoad: 'Failed to load, please try again later.',
            loading: 'Loading...',
            youCannotExceedLoan: 'You cannot exceed ${0} for this loan type.',
            loanCantBeLessThan: 'Your loan cannot be less than ${0}.',
            loanCantBeLargerThan: 'Your loan cannot be larger than ${0}.',
            refinanceCantBeGreaterThanHomeValue: 'Your refinance amount cannot be greater than the home value.',
            ltvShouldBeValueOrLess: 'Your Loan-To-Value should be {0}% or less for this loan type.',
        },
        es: {
            downPaymentLargerThanPurchasePrice: 'Su pago inicial no puede ser igual o mayor que el precio de compra.',
            enterDownPaymentMinimum: 'Ingrese un pago inicial de {0}% o más para este tipo de préstamo.',
            failedToLoad: 'No se pudo cargar, por favor intente nuevamente más tarde.',
            loading: 'Cargando...',
            youCannotExceedLoan: 'Usted no puede exceder los ${0} para este tipo de préstamo.',
            loanCantBeLessThan: 'Su préstamo no puede ser menor a ${0}.',
            loanCantBeLargerThan: 'Su préstamo no puede ser mayor a ${0}.',
            refinanceCantBeGreaterThanHomeValue: 'El monto de su refinanciamiento no puede ser mayor al valor de la vivienda.',
            ltvShouldBeValueOrLess: 'Su relación préstamo-valor debe ser de {0}% o menos para este tipo de préstamo.',
        },
    }
    return translationStrings[lang];
}
